/**
 * คำเตือนหน้าสร้างสัญญาหลัก — "บริษัทนี้มีสัญญาอยู่แล้ว" (ไม่บล็อก)
 *
 * แก้ 3 พ.ย. 2026: เดิมประโยคร่างขึ้นต้นด้วย "และมีร่างสัญญา…" เสมอ — บริษัทที่มีแต่ร่าง (ไม่มีฉบับที่มีผล)
 * เลยอ่านได้ประโยคห้วน ๆ ขึ้นต้นด้วย "และ" · ตัวเลขนับมาจาก `GET /contracts?top_level_only=true`
 * (สัญญาระดับบนสุดเท่านั้น — ไม่รวมแนบท้าย) ประกอบประโยคที่นี่ที่เดียวเพื่อให้ทดสอบได้ทุกกรณี
 */
export interface ContractCountSummary {
  activeTotal: number;
  activeNumbers: string[];
  draftTotal: number;
  draftNumbers: string[];
}

const listNumbers = (numbers: string[], total: number) =>
  numbers.length > 0 ? ` (${numbers.slice(0, 3).join(', ')}${total > 3 ? ' …' : ''})` : '';

/** คืนบรรทัดคำเตือน 0–2 บรรทัด ตามกรณี มีผลอย่างเดียว / ร่างอย่างเดียว / ทั้งสองอย่าง */
export function companyContractWarningLines(s: ContractCountSummary): string[] {
  const lines: string[] = [];
  if (s.activeTotal > 0) {
    lines.push(`บริษัทนี้มีสัญญาที่ยังมีผลอยู่แล้ว ${s.activeTotal} ฉบับ${listNumbers(s.activeNumbers, s.activeTotal)}`);
  }
  if (s.draftTotal > 0) {
    const lead = s.activeTotal > 0 ? 'และมีร่างสัญญา' : 'บริษัทนี้มีร่างสัญญา';
    lines.push(`${lead}ที่ยังไม่ได้อนุมัติ ${s.draftTotal} ฉบับ${listNumbers(s.draftNumbers, s.draftTotal)}`);
  }
  return lines;
}
